exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-54b520f0]{color:#666;font-size:14px}.tip-content[data-v-54b520f0]{width:335px;height:207px;background-color:#fff;margin:0 auto;z-index:9999}.tip-content p[data-v-54b520f0]{text-align:center}.tip-content .tip-title[data-v-54b520f0]{padding-top:50px;padding-bottom:20px;font-size:18px;color:#666;line-height:25px}.tip-btn a[data-v-54b520f0]{background:#f5f5f5;border:1px solid #a28b77;font-size:18px;color:#a28b77;display:inline-block;width:167px;height:44px;line-height:44px;margin-top:28px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-54b520f0","scoped":true,"hasInlineConfig":true}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/common/tip-dialog.vue
// module id = 122
// module chunks = 2 4 6